import { createSelector } from 'reselect';
import { assign } from 'lodash';

const selectEstimate = state => state.screens.EstimateView.estimate;
const selectEditable = state => state.screens.EstimateView.editable;

export default createSelector(
  [selectEstimate, selectEditable],
  (estimate, editable) => {

    if (!estimate) return [];

    let incrementer = 0;

    const items = [];

    estimate.estimate_groups.forEach((estimateGroup, estimateGroupIndex) => {

      items.push({
        type: 'GroupHeader',
        height: 60,
        estimateGroup,
        estimateGroupIndex
      });

      estimateGroup.estimate_items.forEach((estimateItem, estimateItemIndex) => {

        let lineNumber = null;

        if (estimateItem.type) {
          incrementer += 1;
          lineNumber = incrementer;
        }

        items.push({
          type: 'GroupItem',
          height: 50,
          estimateGroup,
          estimateGroupIndex,
          estimateItem: assign({}, estimateItem, { line_number: lineNumber }),
          estimateItemIndex
        });

      })

      if (estimateGroup.estimate_items.length === 0) {

        items.push({
          type: 'GroupPlaceholder',
          height: 50,
          estimateGroup,
          estimateGroupIndex
        });

      }

      items.push({
        type: 'GroupFooter',
        height: 60,
        estimateGroup,
        estimateGroupIndex
      });

    })

    if (estimate.estimate_groups.length > 0) {

      items.push({
        type: 'Footer',
        height: editable ? 190 : 90
      });

    } else {

      items.push({
        type: 'Placeholder',
        height: 100
      });

    }

    return items;

  }
)
